<template>
  <VModal :show="show" :title="title" type="small">
    <form @submit.prevent="submit">

      <div class="mt-5">
        <label>وضعیت</label>
        <select class="w-full bg-dark-form rounded-lg p-3 mt-2" v-model="status">
          <option value="" disabled>وضعیت</option>
          <option value="pending">در انتظار</option>
          <option value="seen">دیده شده</option>
          <option value="delivered">تحویل شده</option>
          <option value="rejected">رد شده</option>
        </select>
      </div>

      <div class="mt-5" v-if="status === 'rejected'">
        <label>علت رد</label>
        <VInput type="text" v-model="deny_reason" class="mt-2" placeholder="علت رد ..." required/>
      </div>

      <div class="flex gap-5 w-full mt-8">
        <VButton class="w-full">تایید</VButton>
      </div>
    </form>

    <VLoadingScreen :show="loading"/>
  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VButton from "@/components/General/VButton";
import {updateOrder} from "@/API/API";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import VInput from "@/components/General/VInput";

export default {
  name: "ModalOrderStatus",
  components: {VInput, VLoadingScreen, VButton, VModal},
  props: ['show', 'title', 'invoiceItem'],
  data() {
    return {
      loading: false,
      status: '',
      deny_reason: ''
    }
  },
  methods: {
    async submit() {
      this.loading = true
      let resp = await updateOrder(this.invoiceItem.id, this.status, this.deny_reason)
      this.loading = false
      this.$emit('updated', resp.data)
    }
  }
}
</script>

<style scoped>

</style>